import { useMemo } from 'react';

import { ExternalCell, ExternalRow, Stack, tokens } from '@cast/design-system';
import { toDateTimePrecise } from '@cast/utils';

import { CopyToClipboard } from 'components/clickable-actions';

import { DetailsRowContainer } from './DetailsRowContainer';
import { CPUPressureResolvedEvent } from '../../../types';

export const CPUPressureResolvedEventSubRow = (
  event: CPUPressureResolvedEvent
) => {
  // Sort containers by startedAt timestamp for chronological display
  const sortedContainers = useMemo(
    () =>
      [...(event.details.containers || [])].sort(
        (a, b) =>
          new Date(a.startedAt).getTime() - new Date(b.startedAt).getTime()
      ),
    [event.details.containers]
  );

  return (
    <DetailsRowContainer event={event}>
      {/* Resolution timeline table */}
      {!!sortedContainers.length && (
        <>
          <ExternalRow
            height={36}
            typography="L10B"
            color="grey.700"
            sx={{
              borderTop: '1px solid',
              borderColor: tokens.theme.border.structural.neutral,
            }}
          >
            <ExternalCell>Container</ExternalCell>
            <ExternalCell startColumn={1}>Started At</ExternalCell>
            <ExternalCell startColumn={2}>Stopped At</ExternalCell>
          </ExternalRow>

          {sortedContainers.map(({ name, startedAt, stoppedAt }) => (
            <ExternalRow key={name} height={28}>
              <ExternalCell startColumn={0} cellProps={{ typography: 'P12R' }}>
                <Stack direction="row" gap={4} alignItems="center">
                  <CopyToClipboard text={name} iconSize={16} />
                  {name}
                </Stack>
              </ExternalCell>
              <ExternalCell
                startColumn={1}
                cellProps={{ typography: 'P12R', color: 'grey.600' }}
              >
                {toDateTimePrecise(startedAt)}
              </ExternalCell>
              <ExternalCell
                startColumn={2}
                cellProps={{ typography: 'P12R', color: 'grey.600' }}
              >
                {toDateTimePrecise(stoppedAt)}
              </ExternalCell>
            </ExternalRow>
          ))}
        </>
      )}
    </DetailsRowContainer>
  );
};
